module.exports = __webpack_public_path__ + "img/douyin.5fa293d4.png";